/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedContactSellerButton_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_viewer">;
    readonly " $refType": "PdpSharedContactSellerButton_viewer";
};
export type PdpSharedContactSellerButton_viewer$data = PdpSharedContactSellerButton_viewer;
export type PdpSharedContactSellerButton_viewer$key = {
    readonly " $data"?: PdpSharedContactSellerButton_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactSellerButton_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedContactSellerButton_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'dcc00836a842a1857051dfbdf82b07ac';
export default node;
